import { apiFetch } from './client'

export interface PortalPatient {
  id: number
  name: string
  species: string
  breed: string | null
  sex: string
  is_desexed: boolean | null
  weight_kg: number | null
  color: string | null
  photo_url: string | null
  date_of_birth: string | null
  notes: string | null
}

export interface PortalAppointment {
  id: number
  patient_id: number
  patient_name: string | null
  practice_name: string | null
  scheduled_at: string
  duration_minutes: number
  appointment_type: string
  reason: string | null
  status: string
}

export interface PortalInvoiceSummary {
  id: number
  invoice_number: string
  patient_id: number | null
  patient_name: string | null
  status: string
  issued_date: string
  due_date: string | null
  total_amount: string
}

export async function getPortalPatients(): Promise<PortalPatient[]> {
  const res = await apiFetch('/api/portal/me/patients')
  if (!res.ok) throw new Error('Failed to load pets.')
  return res.json() as Promise<PortalPatient[]>
}

export async function getPortalAppointments(): Promise<PortalAppointment[]> {
  const res = await apiFetch('/api/portal/me/appointments')
  if (!res.ok) throw new Error('Failed to load appointments.')
  return res.json() as Promise<PortalAppointment[]>
}

export async function getPortalInvoices(): Promise<PortalInvoiceSummary[]> {
  const res = await apiFetch('/api/portal/me/invoices')
  if (!res.ok) throw new Error('Failed to load invoices.')
  return res.json() as Promise<PortalInvoiceSummary[]>
}
